/**
 *
 * EditControl
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose } from 'redux';
import { injectIntl, intlShape } from 'react-intl';
import withEdit from 'containers/EditService/withEdit';
import { editStatus } from 'containers/EditService/functions/Leg';
import { STATUS_NONE } from 'containers/EditService/constants';
import withRoute from 'containers/Routes/withEntity';
import withUser from 'containers/User/withUser';
import SaveModal from 'components/SaveModal';
import IconButton from 'components/IconButton';
import toggleState from 'utils/toggleState';
import EditActions from './EditActions';
import messages from './messages';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .btn + .btn {
    margin-top: 10px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class EditControl extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { show: false };
    this.toggleShow = toggleState('show').bind(this);
    this.save = this.save.bind(this);
    this.editCurrent = this.editCurrent.bind(this);
  }

  static getDerivedStateFromProps(props) {
    const { workingRoute } = props;
    if (editStatus(workingRoute.legs) === STATUS_NONE) {
      return { show: false };
    }
    return {};
  }

  save() {
    const { saveRoute } = this.props;
    saveRoute();
    this.toggleShow();
  }

  editCurrent() {
    const { editRoute, currentRoute } = this.props;
    editRoute(currentRoute);
  }

  renderCreate() {
    const { createRoute, intl } = this.props;
    return (
      <IconButton
        id="edit-action"
        bsStyle="danger"
        className="btn-fab btn-lg"
        onClick={createRoute}
        icon="plus"
        title={intl.formatMessage(messages.create)}
        aria-label="Create route"
      />
    );
  }

  renderEdit() {
    const { intl, currentRoute, user } = this.props;
    if (!currentRoute || currentRoute.loading) {
      return null;
    }
    const userId = user.api && user.api.userId;
    const isOwn = currentRoute.user_id === userId;
    const icon = isOwn ? 'pen' : 'clone';
    const message = isOwn ? messages.edit : messages.copy;
    return (
      <IconButton
        id="edit-action"
        bsStyle="danger"
        className="btn-fab btn-lg"
        onClick={this.editCurrent}
        icon={icon}
        title={intl.formatMessage(message)}
        aria-label="Edit route"
      />
    );
  }

  renderWorking() {
    const { workingRoute } = this.props;
    const { show } = this.state;
    return (
      <React.Fragment>
        <Wrapper className="leaflet-control-edit">
          <EditActions {...this.props} onSave={this.save} />
        </Wrapper>
        {show && <SaveModal onHide={this.toggleShow} route={workingRoute} />}
      </React.Fragment>
    );
  }

  render() {
    const { workingRoute, routeId } = this.props;
    if (workingRoute.loading) {
      return null;
    }
    if (workingRoute.legs) {
      return this.renderWorking();
    }
    return (
      <Wrapper>
        {Boolean(routeId) && this.renderEdit()}
        {this.renderCreate()}
      </Wrapper>
    );
  }
}

EditControl.propTypes = {
  workingRoute: PropTypes.object.isRequired,
  createRoute: PropTypes.func.isRequired,
  editRoute: PropTypes.func.isRequired,
  saveRoute: PropTypes.func.isRequired,
  routeId: PropTypes.number,
  currentRoute: PropTypes.object,
  user: PropTypes.object,
  undo: PropTypes.func.isRequired,
  intl: intlShape,
};

export default compose(
  withEdit,
  withRoute,
  withUser,
  injectIntl,
)(EditControl);
